import React from 'react';
import ReactDOM from 'react-dom/client';
import JobForm from './job/JobForm';
const container = document.getElementById('application-form');
const { jobs, preselectedJobId, pageId } = JSON.parse(document.getElementById('application-form-data')?.innerText ?? '');
if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(React.createElement(JobForm, { jobs: jobs, preselectedJobId: preselectedJobId, pageId: pageId }));
}
